import 'font-awesome/css/font-awesome.min.css';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Logo from "../../assets/logo-laser.png";
import "../../styles/Header.css";
import employee from '../../class/employee';
import React from 'react';

const logedEmployee = new employee();

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logedEmployee.logout();
        navigate('/login');
    };

    return (
        <header>
            <div className='header'>
                <div className="logo">
                    <NavLink to="/">
                        <img src={Logo} alt="Logo" />
                    </NavLink>
                </div>
                <div className="btn-group">
                    <div className="phone">
                        {location.pathname !== '/login' && location.pathname !== '/' ? (
                            <button onClick={handleLogout} className="blue_butt">Log out</button>
                        ) : ""}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
